module.exports={
  maxFileUpload:10,
  maxLiveImageContent:30,
  maxBannerLiveContent:10,
  // API_URL:"http://192.168.1.11:5000",
  //API_URL:"http://localhost:5000",
  // API_URL:"https://test.workoutplus.in",
  API_URL:"https://agmconcept.fit",
  // API_URL:"http://localhost:8000",
  prefixAPI:"/api",
  prefixStream:"/stream",
  authToken:{
    token1:"$2b$10$9giflEYsfxzoxug98PEJTeohqCZWtZp.siSq3WTNOhZ1o6duy1cvK"
  },
  // videoDistributionHost:"https://d23k98lnd50fsd.cloudfront.net",
  videoDistributionHost:"https://d2kg7p3dwcjyq0.cloudfront.net",
  unAuthParam:"secret=instafit-app-secret134&token=jhsasjalsjlksjakjsn121n",
  wpAuthToken:"$2b$10$9giflEYsfxzoxug98PEJTeohqCZWtZp.siSq3WTNOhZ1o6duy1cvK",
  firebaseConfig:{
    apiKey: "AIzaSyDP5qgFjK8gXLMUDgSb_u9yV3-1VJOiAms",
    authDomain: "workoutplus-7278b.firebaseapp.com",
    projectId: "workoutplus-7278b",
    storageBucket: "workoutplus-7278b.appspot.com",
    messagingSenderId: "302278372183",
    appId: "1:302278372183:web:5102abd41923133bb0ec12",
    measurementId: "G-GY36RBG0Z0"
  },
  weekDays:['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
  monthNames:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
  weekDayDisplayNames:{
    'Sun':'Sunday',
    'Mon':'Monday',
    'Tue':'Tuesday',
    'Wed':'Wednesday',
    'Thu':'Thursday',
    'Fri':'Friday',
    'Sat':'Saturday'
  },
  roleNames:{
    "workoutplus-admin": "Workoutplus Admin",
    "gym-admin": "Gym Admin",
    "general-trainer": "General Trainer",
    "sales-consultant": "Sales Consultant",
    "personal-trainer": "Personal Trainer",
    "sales-lead": "Sales Manager",
    "personal-trainer-lead": "PT Manager",
    "member": "Member",
    "fitness-lead": "Fitness Manager",
    "nutritionist": "Nutritionist",
    "groupx-lead": "GroupX Manager",
    "receptionist": "Receptionist",
    "security": "Security",
    "freelancer": "Freelancer",
    "cafe-staff": "Cafe Staff",
    "recovery-zone": "Recovery Zone",
    "housekeeping": "House Keeping"
  },
  planDisplayNames:{
    "GymWorkout":"Gym Workout", "PersonalTraining":"Personal Training", "GroupEx":"Group EX", "LybertyMembership":"Lyberty Membership"
  }
}